import Routing from './routing';

export default Routing;
